import { render, staticRenderFns } from "./Timeout.vue?vue&type=template&id=22d926f4"
import script from "./Timeout.vue?vue&type=script&lang=js"
export * from "./Timeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports